import React from "react";

export const LABEL_CLASS = "mb-1.5 block text-xs font-semibold text-gray-700";
export const INPUT_CLASS =
  "h-10 w-full rounded-lg border border-[#E5E7EB] bg-white px-3 text-sm text-gray-900 shadow-sm outline-none transition placeholder:text-gray-400 hover:border-gray-300 focus:border-[#007BFF] focus:ring-1 focus:ring-[#007BFF]/20 disabled:cursor-not-allowed disabled:bg-gray-50 disabled:opacity-70";
export const DATE_INPUT_CLASS = `${INPUT_CLASS} cursor-pointer [&::-webkit-calendar-picker-indicator]:cursor-pointer`;
export const FIELD_CLASS = "add-account-field";
export const ERROR_CLASS = "mt-1 text-xs text-red-500";
export const SECTION_CLASS =
  "rounded-xl border border-[#E5E7EB] bg-[#FAFBFC] p-4";

export function openPicker(event) {
  if (event.currentTarget.disabled) return;
  try {
    event.currentTarget.showPicker?.();
  } catch {
    // showPicker requires a direct user gesture in some browsers
  }
}

export function FieldError({ message }) {
  if (!message) return null;
  return <p className={ERROR_CLASS}>{message}</p>;
}

export function calculateProbationPeriod(dateOfJoining) {
  if (!dateOfJoining) return "";
  const date = new Date(dateOfJoining);
  date.setMonth(date.getMonth() + 3);
  return date.toISOString().split("T")[0];
}
